var _rect, _rect2, _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgBiCamera = function SvgBiCamera(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F3F7FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#C4D0D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 27.5625C21.4375 28.5312 22.625 29.0156 24 29.0156C25.375 29.0156 26.5469 28.5312 27.5156 27.5625C28.5156 26.5625 29.0156 25.375 29.0156 24C29.0156 22.625 28.5156 21.4531 27.5156 20.4844C26.5469 19.4844 25.375 18.9844 24 18.9844C22.625 18.9844 21.4375 19.4844 20.4375 20.4844C19.4688 21.4531 18.9844 22.625 18.9844 24C18.9844 25.375 19.4688 26.5625 20.4375 27.5625ZM21 14.0156H27L28.8281 15.9844H32.0156C32.5469 15.9844 33 16.1875 33.375 16.5938C33.7812 17 33.9844 17.4688 33.9844 18V30C33.9844 30.5312 33.7812 31 33.375 31.4062C33 31.8125 32.5469 32.0156 32.0156 32.0156H15.9844C15.4531 32.0156 14.9844 31.8125 14.5781 31.4062C14.2031 31 14.0156 30.5312 14.0156 30V18C14.0156 17.4688 14.2031 17 14.5781 16.5938C14.9844 16.1875 15.4531 15.9844 15.9844 15.9844H19.1719L21 14.0156ZM21.75 26.25C21.125 25.625 20.8125 24.875 20.8125 24C20.8125 23.125 21.125 22.375 21.75 21.75C22.375 21.125 23.125 20.8125 24 20.8125C24.875 20.8125 25.625 21.125 26.25 21.75C26.875 22.375 27.1875 23.125 27.1875 24C27.1875 24.875 26.875 25.625 26.25 26.25C25.625 26.875 24.875 27.1875 24 27.1875C23.125 27.1875 22.375 26.875 21.75 26.25Z",
    fill: "#596975"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBiCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bi_camera.1a23c0c4.svg";
export { ForwardRef as ReactComponent };